<template>
    <div class="flex w-full h-screen overflow-hidden bg-slate-100">
        <div class="flex-1 w-full overflow-hidden">
            <Topbar />

            <div class="mt-[64px] flex h-[calc(100vh-64px)] flex-col overflow-hidden p-4 md:p-5 lg:p-6">
                <RouterLink to="/store" class="mb-3 inline-flex w-fit items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-600 transition-colors hover:border-slate-300 hover:text-slate-900">
                    <i class="pi pi-arrow-left" />
                    Назад
                </RouterLink>

                <div class="mb-4 flex shrink-0 items-start justify-between gap-3">
                    <div>
                        <h2 class="text-2xl font-semibold tracking-tight text-slate-900 md:text-3xl">Тариф за сбор заказа</h2>
                        <p class="mt-1 text-sm text-slate-500 md:text-base">Ежедневная настройка тарифа по типу и уровню сложности заказа</p>
                    </div>
                </div>

                <div class="min-h-0 flex-1 overflow-hidden rounded-2xl border border-slate-200 bg-white p-4 shadow-sm md:p-6">
                <DataTable ref="storePriceTable" :value="stores" editMode="cell"
                    :paginator="true" :rows="10" :rowsPerPageOptions="[5, 10]" resizableColumns  
                    scrollable columnResizeMode="fit" showGridlines stripedRows size="small"
                    class="reference-table h-full"
                    scrollHeight="flex"
                >
                    <!-- :row="10" :rowsPerPageOptions="[5, 10]" tableStyle="min-width:50rem; border-radius=10px" -->
                    <Column field="product_type" header="Заказ" frozen style="min-width:150px" />
                    <Column field="product_level" header="Уровень сложности" style="min-width:120px" />
                    
                    <Column v-for="(col, index) in dateColumns" :key="index" :header="col.label" :field="col.field">
                        <template #body="{ data }">
                            <InputNumber
                                v-if="col.isToday && editingId === data.id"
                                v-model="data.prices[col.field]"
                                style="width: 100px"
                                fluid
                            />
                            <span v-else>{{ (data.prices[col.field]) ? data.prices[col.field].toLocaleString() : '0' + ' ₸' ?? '-' }}</span>
                        </template>
                    </Column>
                    <Column header="Действие" frozen alignFrozen="right" style="min-width:120px">
                        <template #body="{ data }">
                            <div class="flex gap-2 justify-center">
                                <Button
                                  v-if="editingId !== data.id"
                                  icon="pi pi-pencil"
                                  severity="secondary"
                                  size="small"
                                  @click="startEdit(data.id)"
                                />
                                <Button
                                  v-else
                                  icon="pi pi-check"
                                  severity="success"
                                  size="small"
                                  @click="saveEdit(data)"
                                />
                                <Button
                                  v-if="editingId === data.id"
                                  icon="pi pi-times"
                                  severity="danger"
                                  size="small"
                                  @click="cancelEdit"
                                />
                            </div>
                        </template>
                    </Column>
                </DataTable>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from '../lib/axios'

const stores = ref([])
const dateColumns = ref([])
const storePriceTable = ref([])
const editingId = ref(null)
const originalPrice = ref(null)

const fetchData = async () => {
    const { data } = await axios.get('/api/weekly-order-type-prices')
    stores.value = data

    const keys = Object.keys(data[0]?.prices || {})
    const today = new Date().toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' })
    dateColumns.value = keys.map(k => ({
        label: k,
        field: k,
        isToday: k === today
    }))
}

const startEdit = (id) => {
  editingId.value = id
  const store = stores.value.find(s => s.id === id)
  const todayField = dateColumns.value.find(c => c.isToday)?.field
  originalPrice.value = store.prices[todayField]
}

const cancelEdit = () => {
  const store = stores.value.find(s => s.id === editingId.value)
  const todayField = dateColumns.value.find(c => c.isToday)?.field
  if (store && todayField) store.prices[todayField] = originalPrice.value
  editingId.value = null
}

const saveEdit = async (store) => {
    const todayField = dateColumns.value.find(c => c.isToday)?.field
    const newPrice = store.prices[todayField]
    await axios.put(`/api/update-order-type-price/${store.id}/price?price=${newPrice}`)
    editingId.value = null
}

onMounted(fetchData)
</script>

<style scoped>
:deep(.reference-table),
:deep(.reference-table .p-datatable-table-container) {
  height: 100%;
}

:deep(.reference-table .p-datatable-header) {
  border: 0;
  background: rgb(255 255 255);
  padding: 0;
}

:deep(.reference-table .p-datatable-thead > tr > th) {
  background: rgb(248 250 252);
  color: rgb(71 85 105);
  font-weight: 600;
  border-color: rgb(226 232 240);
  padding: 0.875rem 1rem;
}

:deep(.reference-table .p-datatable-tbody > tr > td) {
  border-color: rgb(241 245 249);
  color: rgb(51 65 85);
  padding: 0.875rem 1rem;
}

:deep(.reference-table .p-datatable-tbody > tr:hover > td) {
  background: rgba(248, 250, 252, 0.95);
}

:deep(.reference-table .p-paginator) {
  border-top: 1px solid rgb(226 232 240);
  background: rgb(255 255 255);
  padding: 0.75rem 1rem;
}

:deep(.reference-table .p-paginator-page.p-paginator-page-selected) {
  background: rgb(16 185 129);
  color: rgb(255 255 255);
}

.p-datatable td {
  text-align: center;
}
</style>
